// extracted by mini-css-extract-plugin
module.exports = {"buttonBack":"ButtonBack_buttonBack__2ureB"};